import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import StickyCommander from "@/components/StickyCommander";
import HomePage from "@/pages/HomePage";
import ProductsPage from "@/pages/ProductsPage";
import T1Page from "@/pages/T1Page";
import T2Page from "@/pages/T2Page";
import T3Page from "@/pages/T3Page";
import AboutPage from "@/pages/AboutPage";
import ContactPage from "@/pages/ContactPage";
import MentionsLegalesPage from "@/pages/MentionsLegalesPage";
import FAQPage from "@/pages/FAQPage";
import OrderPage from "@/pages/OrderPage";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function AppContent() {
  return (
    <>
      <ScrollToTop />
      <Header />
      <main>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/produits" element={<ProductsPage />} />
          <Route path="/produits/t1" element={<T1Page />} />
          <Route path="/produits/t2" element={<T2Page />} />
          <Route path="/produits/t3" element={<T3Page />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/mentions-legales" element={<MentionsLegalesPage />} />
          <Route path="/faq" element={<FAQPage />} />
          <Route path="/commander" element={<OrderPage />} />
        </Routes>
      </main>
      <Footer />
      <StickyCommander />
      <Toaster position="bottom-center" />
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}

export default App;
